import { isValidEmail as isValidEmailWithRegexp } from "shared/utils/is-valid-email";

export const validateHeaders = <T extends readonly string[]>(headers: string[], requiredHeaders: T): { [key in T[number]]: number }  => {
  const result = requiredHeaders.reduce((result, requiredHeader) => ({ ...result, [requiredHeader]: headers.indexOf(requiredHeader) }), {} as { [key in T[number]]: number; });

  const missings = Object.entries(result).filter(([_, index]) => index === -1);

  if (missings.length > 0) {
    throw new Error(`Не найдены колонки: ${missings.map(([key]) => key).join(', ')}`);
  }

  return result;
}

export const isNotEmpty = (value: string) => {
  if (value.trim() === '') {
    return `Ошибка валидации: значение не может быть пустым`;
  }
};

export const isValidEmail = (value: string) => {
  if (value.includes(' ')) {
    return `Ошибка валидации: ${value} содержит недопустимый пробел`;
  }
  
  if (!isValidEmailWithRegexp(value)) {
    const invalidChar = value.match(/[^+a-zA-Z0-9@._-]/)?.[0] || '';
    return `Ошибка валидации: ${value} содержит недопустимый символ ${invalidChar}`;
  }
};

export const isValidDate = (value: string) => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  
  if (!dateRegex.test(value)) {
    return `Ошибка валидации: ${value} не соответствует формату YYYY-MM-DD`;
  }
  
  const date = new Date(value);
  
  if (isNaN(date.getTime())) {
    return `Ошибка валидации: ${value} не является действительной датой`;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  
  if (formattedDate !== value) {
    return `Ошибка валидации: ${value} не является действительной датой`;
  }
};

export const isAfter = (date: Date) => {
  const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  return (value: string) => {
    if (new Date(value) < date) {
      return `Ошибка валидации: ${value} должно быть не раньше ${dateString}`;
    }
  }
};

export const isBefore = (date: Date) => {
  const dateString = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  return (value: string) => {
    if (new Date(value) > date) {
      return `Ошибка валидации: ${value} должно быть не позже ${dateString}`;
    }
  }
};

export const onlyLatinOrCyrillic = (value: string) => {
  const hasCyrillic = /[а-яА-ЯёЁ]/.test(value);
  const hasLatin = /[a-zA-Z]/.test(value);

  if (hasCyrillic && hasLatin) {
    return `Ошибка: Содержит (${value}) недопустимую смесь латинских и кириллических символов.`;
  }
}

export const isValidNumber = (value: string | number) => {
  const number = Number(value);

  if (isNaN(number) || !Number.isInteger(number)) {
    return `Ошибка: ${value} должно быть целым числом.`;
  }
}

export const isMoreThan = (number: number) => {
  return (value: string | number) => {
    if (Number(value) < number) {
      return `Ошибка: ${value} должно быть больше ${number}.`;
    }
  }
}

export const isLessThan = (number: number) => {
  return (value: string | number) => {
    if (Number(value) > number) {
      return `Ошибка: ${value} должно быть меньше ${number}.`;
    }
  }
}
